















































import { StructureError } from '@/models'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class StructureErrorsModal extends Vue {
  @Prop({ required: true, type: Array }) errors: StructureError[]

  get fields() {
    return [
      { key: 'elementName', label: `${this.$t('structure_errors_modal.column_element')}` },
      { key: 'code', label: `${this.$t('structure_errors_modal.column_code')}` },
      { key: 'fileName', label: `${this.$t('structure_errors_modal.column_file')}` },
      { key: 'type', label: `${this.$t('structure_errors_modal.column_type')}` }
    ]
  }

  get items() {
    return this.errors.map((error: StructureError) => ({
      elementName: error.elementName,
      code: error.code,
      fileName: error.fileName,
      type: `${this.$t('structure_errors_modal.types.' + error.type)}`
    }))
  }
}
